import React from 'react';
import styled from 'styled-components'
import ArticleNum from './ArticleNum';
import DevanshPhoto from '../assets/images/devansh.jpeg';

function WhoCont() {
    return (
        <Who>
            <div className="left-container">
                <ArticleNum number="01" title="WHO I AM" />
            </div>  
            <div className="right-container" >
                <div className="inner-container">
                    <p className="fs-2 name ">DEVANSH  BATRA</p>
                    <p className='text-tertiary para ' >
                        Software Developer with 2+ years of experience building and maintaining high-impact backend microservices in the telecom billing domain. I work closely with production systems-improving performance, optimizing complex APIs, and designing scalable services that are built to operate reliably at scale.
                    </p>
                    <p className='para text-tertiary' >
                        Alongside backend development, I have hands-on full-stack exposure, enabling me to contribute to end-to-end features when needed and collaborate effectively across teams.
                    </p>
                    <p className='para text-tertiary' >
                        I’m currently deepening my understanding of system design and software architecture, with a growing interest in applying AI-driven approaches to optimize workflows and improve system efficiency.
                    </p>
                    <p className='para text-tertiary' >
                        Always happy to connect or collaborate on interesting ideas - especially the fun ones.
                    </p>
                    <img src={DevanshPhoto} alt="" />
                </div>
            </div>
        </Who>
    );
}

const Who = styled.div`
    display: flex;
    align-items: flex-start;
    background-color: var(--white); 
    /* border: 2px solid black; */
    
    .left-container{
        width: 50%;
        display: flex;
        /* border: 2px solid black; */
    }
    .right-container{
        /* border: 2px solid black; */
        width: 50%;
    }
    .inner-container{
        width: 70%;
    }
    .name{
        color: var(--primary);
        margin-bottom: 2rem;
    }
    .para{
        text-align: justify;
    }
    img{
        width: 100%;
        object-fit: cover;
        margin: 3rem 0rem;
        box-shadow: 2px 80px 150px -55px #4d0d0d61;
    }

    @media only screen and (max-width: 500px){

        flex-direction: column;

        .left-container{
            width: 100%;
            display: flex;
            /* border: 2px solid black; */
        }
        .right-container{
            /* border: 2px solid black; */
            margin-top: 2rem;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .inner-container{
            width: 70%;
        }
    }

`;

export default WhoCont;